/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'room': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="#F7B500" d="M11.667 0H.333A.333.333 0 000 .333v10c0 .184.15.334.333.334H4.55l1.575 1.26a.331.331 0 00.469-.052.333.333 0 00-.052-.469l-1.667-1.333-.01-.007a.374.374 0 00-.03-.02l-.028-.014a.34.34 0 00-.128-.03L4.667 10H4V9a.333.333 0 10-.667 0v1H.667V5.333h2.666V7A.333.333 0 104 7V5.333h3.667a.333.333 0 100-.666h-7v-4h10.666v4H9.667a.333.333 0 100 .666h1.666V10h-4a.333.333 0 100 .667h4.334c.184 0 .333-.15.333-.334v-10A.333.333 0 0011.667 0z"/>'
  }
})
